import React, { Component } from 'react';
import { Layout, Button } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const { Content } = Layout;

const ToSWrapper = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const StyledContent = styled(Content)`
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: #fff;
  margin-top: 20px;
  margin-bottom: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 30px 15px;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    padding: 20px 10px;
    margin: 10px;
    border-radius: 4px;
  }

  h2 {
    font-size: 2em;
    margin-bottom: 20px;
    color: #333;

    @media (max-width: 768px) {
      font-size: 1.75em;
    }

    @media (max-width: 480px) {
      font-size: 1.5em;
    }
  }

  h3 {
    font-size: 1.5em;
    margin-top: 30px;
    margin-bottom: 15px;
    color: #333;

    @media (max-width: 768px) {
      font-size: 1.3em;
    }

    @media (max-width: 480px) {
      font-size: 1.2em;
    }
  }

  p {
    font-size: 1em;
    line-height: 1.8;
    margin-bottom: 15px;
    color: #666;

    @media (max-width: 768px) {
      font-size: 0.95em;
      line-height: 1.7;
    }

    @media (max-width: 480px) {
      font-size: 0.9em;
      line-height: 1.6;
    }
  }

  ol {
    margin-bottom: 15px;
    padding-left: 20px;

    @media (max-width: 480px) {
      padding-left: 15px;
    }

    li {
      font-size: 1em;
      line-height: 1.8;
      color: #666;
      margin-bottom: 8px;

      @media (max-width: 768px) {
        font-size: 0.95em;
      }

      @media (max-width: 480px) {
        font-size: 0.9em;
      }
    }
  }

  a {
    color: #1890ff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const BackButtonWrapper = styled.div`
  max-width: 1000px;
  margin: 20px auto 0;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
    margin-top: 10px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

class ToS extends Component {
  render() {
    return (
      <ToSWrapper>
        <Layout>
          <BackButtonWrapper>
            <Link to="/">
              <Button type="default" icon="arrow-left" size="large">
                Back to Homepage
              </Button>
            </Link>
          </BackButtonWrapper>
          <StyledContent>
            <h2>WifiBiz Terms of Service</h2>
            <h3>1. Terms</h3>
            <p>By using or accessing the website at <a href="https://wifibiz.net">https://wifibiz.net</a>, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p>
            <h3>2. Use License</h3>
            <ol type="a">
             <li>Permission is granted to temporarily download one copy of the materials (information or software) on WifiBiz's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
             <ol type="i">
                 <li>modify or copy the materials;</li>
                 <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
                 <li>attempt to decompile or reverse engineer any software contained on WifiBiz's website;</li>
                 <li>remove any copyright or other proprietary notations from the materials; or</li>
                 <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
             </ol>
              </li>
             <li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by WifiBiz at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li>
            </ol>
            <h3>3. Disclaimer</h3>
            <ol type="a">
             <li>The materials on WifiBiz's website are provided on an 'as is' basis. WifiBiz makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</li>
             <li>Further, WifiBiz does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</li>
            </ol>
            <h3>4. Limitations</h3>
            <p>In no event shall WifiBiz or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on WifiBiz's website, even if WifiBiz or a WifiBiz authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
            <h3>5. Accuracy of materials</h3>
            <p>The materials appearing on WifiBiz's website could include technical, typographical, or photographic errors. WifiBiz does not warrant that any of the materials on its website are accurate, complete or current. WifiBiz may make changes to the materials contained on its website at any time without notice. However WifiBiz does not make any commitment to update the materials.</p>
            <h3>6. Links</h3>
            <p>WifiBiz has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by WifiBiz of the site. Use of any such linked website is at the user's own risk.</p>
            <h3>7. Modifications</h3>
            <p>WifiBiz may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
            <h3>8. Governing Law</h3>
            <p>These terms and conditions are governed by and construed in accordance with the laws of Vietnam and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
          </StyledContent>
        </Layout>
      </ToSWrapper>
    );
  }
}

export default ToS;

